export const lang={
    indexname:'惠威swan',
    index_li1:'Brand Story',
    index_li2:'Product',
    index_li3:'About Us',
    index_li4:'Common Problems',
    index_li5:'Contact Us',
    go_home:'Return to the home page',
    RMB:'$',
    Record_1:'© X-Speaker 2023',
    Record_2:'粤ICP备11013245号',
    detail_title:'Brand Introduction',
    list_header:'Technical specifications',
    list_Freight:'Freight : ',
    list_Freight1:'Free Shipping',
    Product_Buy_now:'Buy Now',
    about_text1:'Swans origins from China and has worldwide reputation. After 30 years fast growth, Swans is now one of the renowned high-end audio manufacturers in the world and is highly acclaimed for its so many remarkable loudspeaker products. ',
    about_text2:'In 1997, Swans merged with Swans Speaker Systems, a highly regarded American audio manufacturer. And Swans logo was born.',
    about_text3:'Swans manufactures not only raw drivers but also finished speaker systems. Its product line covers Hi-Fi and Hi-end speaker drivers, home theater speaker systems, solution for digital sound reproduction, active speakers, amplifiers, wifi speakers, hi-end headphones, car speakers and amplifiers, pro audio speakers, public address systems, and speaker enclosures.',
    about_text4:'The company has all kinds of up-to-date R&D equipment and design software to ensure it is always in the leading position in this profession. It includes two large professional anechoic chambers that the cut-off Frequencies can reach 50Hz and 60Hz.',
    about_text5:'Swans 17 times honor CES Innovation Awards, including two “Best of CES”, mark its ability to innovate electroacoustic technology. As Hi-End audio manufacturer, Swans is appraised internationally as follows:',
    about_text6:"With advanced electroacoustic technology combined with China's precision industrial manufacturing, Swans products have excellent sound quality and cost performance.",
    about_text7:'Swans loudspeaker won the favor and adoption of many famous audio manufacturers in Europe and America with its excellent quality and perfect sound. They believe that Swans lead the trend of the audio industry. ',
    about_text8:'Swans is Chinese A-share listed companies, Stock Name: Swans Technology, code:sz.002888',
    about_text9:'Swans is committed to the pursuit of perfect sound playback. Our philosophy: Swans hear the difference Swans, focus on sound.',
    about_text10:'©2020 Swans and the Swans logo are registered trademarks of Swans or its subsidiaries in China and other countries. All rights reserved',
    phone:'Tel',
    
    Callus:`  <p>如有任何问题请与我们联系！</p>
    <p>为您在线解答售前(5×8)、售后咨询(7×24)服务。</p>
    <p>电话：4000909199</p>
    <br>
    <p>地址：深圳市南山区沙河街道高发社区侨香路4068号智慧广场A栋1101</p>
    <p>邮编：518053</p>
    <p>电话总机：0755-82732010</p>
    <p>电邮：hrsz@hivi.com</p>`
}































 





   



